import React, { useContext } from 'react';

import Pagina from '../../components/Pagina';
import SecaoDashboard from '../../components/Dashboard';
import Context, { IContext } from '../../context/Context';
import { DASHBOARDS_INICIO } from '../../constants/dashboards';

// Os atalhos ficam no menu lateral (desktop) e no menu do celular; aqui entram os dashboards
export default function Inicio() {
  const { dadosUsuario, empresa }: IContext = useContext(Context);

  return (
    <Pagina
      titulo={dadosUsuario?.nome ? `Olá, ${dadosUsuario.nome}` : 'Início'}
      subtitulo={empresa ? `${empresa.raz} - ${empresa.fil}` : undefined}
    >
      {DASHBOARDS_INICIO.map(dash => <SecaoDashboard key={dash.id} dash={dash} />)}
    </Pagina>
  );
}
